module.exports = __webpack_public_path__ + "static/img/3059_phase_function_Paper_PointsHejduk_Prediction.e541c96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3059_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 6z2/
// module chunks = 0